// extracted by mini-css-extract-plugin
export var bodyRow = "_gl-d";
export var cardColumns = "_gl-e";
export var ellipsesOverflow = "_gl-2";
export var flatBottomCorners = "_gl-3";
export var flatTopCorners = "_gl-4";
export var headerActionsDropdown = "_gl-f";
export var headerBottomRow = "_gl-c";
export var headerTopRow = "_gl-b";
export var orderDetailsWrapper = "_gl-0";
export var orderInfoContainer = "_gl-1";
export var productDetails = "_gl-9";
export var productImage = "_gl-5";
export var responsiveTable = "_gl-8";
export var shipmentContainer = "_gl-a";
export var tableBottomLeft = "_gl-6";
export var tableBottomRight = "_gl-7";